export default __webpack_public_path__ + "static/media/640_store05-jp-mobile.b62723aa.png";